/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Project_NameInputs */

const en_options_general_project_name = /** @type {(inputs: Options_General_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Name`)
};

const fr_options_general_project_name = /** @type {(inputs: Options_General_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du projet`)
};

const de_options_general_project_name = /** @type {(inputs: Options_General_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektname`)
};

const it_options_general_project_name = /** @type {(inputs: Options_General_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del progetto`)
};

const ru_options_general_project_name = /** @type {(inputs: Options_General_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название проекта`)
};

const es_options_general_project_name = /** @type {(inputs: Options_General_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del proyecto`)
};

const zh_cn2_options_general_project_name = /** @type {(inputs: Options_General_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目名称`)
};

const ja_options_general_project_name = /** @type {(inputs: Options_General_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト名`)
};

const hi_options_general_project_name = /** @type {(inputs: Options_General_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना का नाम`)
};

const pt_pt2_options_general_project_name = /** @type {(inputs: Options_General_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do projeto`)
};

/**
* | output |
* | --- |
* | "Project Name" |
*
* @param {Options_General_Project_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_project_name = /** @type {((inputs?: Options_General_Project_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Project_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_project_name(inputs)
	if (locale === "de") return de_options_general_project_name(inputs)
	if (locale === "it") return it_options_general_project_name(inputs)
	if (locale === "ru") return ru_options_general_project_name(inputs)
	if (locale === "es") return es_options_general_project_name(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_project_name(inputs)
	if (locale === "ja") return ja_options_general_project_name(inputs)
	if (locale === "hi") return hi_options_general_project_name(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_project_name(inputs)
	return en_options_general_project_name(inputs)
});